import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../Input/Index";
import { consentByPass } from "../../store/actions/proposalActions";
import TabContainer from "../Tabs";
import { Tab } from "react-bootstrap";
import Application from "../../containers/proposals/applications_details";
import Product from "../../containers/proposals/product";
import HealthQuestions from "../../containers/proposals/HealthQuestions";
import Declaration from "../../containers/proposals/declaration";
import Nominee from "../../containers/proposals/nominee";
import PropserDetails from "../../containers/proposals/proposerDetails/PropserDetails";
import InsuredDetails from "../../containers/proposals/insuredDetails";
import DocumentDetails from "../../containers/proposals/documentdetails";
import PaymentDetails from "../../containers/proposals/PaymentDetails";
import ImportantLink from "../../containers/proposals/ImportantLink";
import ProposalLogs from "../../containers/proposals/logs";
import MobilePopUp from "../MobilePopUp/MobilePopUp";
import TPADetails from "../../containers/TPA_MedicalScheduling/TPADetails";
import { tpaPoposal } from "../../store/actions/tpaActions";
import { getProposalDetails } from "../../store/actions/proposalActions";
import { getApiStatus } from "../../store/actions/switchAPIAction";
import closeImg from "../../Assets/images/close.svg";


import { useEffect } from "react";
const ProposalDetailsComp = ({ proposalData, proposalNumber }) => {
  const dispatch = useDispatch();
  const statusPanON = useSelector(
    (state) => state?.switchApiReducer?.switchApiData?.waiveOffMedicalsPanIndia
  );

  const dataProposal = useSelector(state => state?.proposal?.proposalData?.tpaWaiveOffDetails)
  // console.log('dataProposal',dataProposal, !dataProposal)

  const [consent, setConsent] = useState({
    agentConsentByPass: false,
    customerConsentByPass: false,
  });
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [selectedOption, setSelectedOption] = useState("");
  const [waivedOff, setShowWaivedOff] = useState(false);
  const [waivedType, setWaivedType] = useState(dataProposal !== null ? dataProposal?.tpaWaiveOffType : '');
  const [waivedRadio, setShowWaivedRadio] = useState(
    dataProposal?.tpaWaiveOffForProposer ? 'Proposer' :
      dataProposal?.tpaWaiveOffForInsured ? 'Insurer' :
        dataProposal?.tpaWaiveOffForBoth ? 'Both' : ''
  );

  const [disabledOptions, setDisabledOptions] = useState([]);
  const [activeTpa, setactiveTpa] = useState(false);
  const [tpaTab, showTpaTab] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [showTpaPan, setshowTpaPan] = useState(false);
  const [TPAData, setTPAData] = useState(""); //single proposal data


  // const [proposalNumber, setProposalNumber] = useState("");
  // const { proposalData } = useSelector((state) => ({
  //     proposalData: state.proposal.proposalData,
  // }));
  // const dispatch = useDispatch();

  // useEffect(() => {
  //     return () => {
  //         dispatch({
  //             type: "PROPOSAL_DATA_CLEAR"
  //         })
  //     }
  // },[])
  // const getProposal = useCallback(() => {
  //     dispatch(getProposalDetails(proposalNumber));
  // }, [proposalNumber, dispatch]);
  // console.log("opsssssssssss", proposalData, proposalData.proposalNumber);

  useEffect(() => {
    // Fetch status api
    dispatch(getApiStatus());
  }, [dispatch]);
  useEffect(() => {
    const {
      agentConsent,
      agentConsentRequired,
      agentConsentLink,
      accepted,
      customerConsentRequired,
      customerConsentLink,
      verified,
    } = proposalData.consentDetails ?? {};
    const agentConsentByPass = !agentConsent && agentConsentRequired;
    const customerConsentByPass =
      (verified === null || verified === false) &&
      (accepted === null || accepted === false) &&
      customerConsentRequired;
    setConsent({
      agentConsentByPass,
      customerConsentByPass,
    });
    setSelectedOption("");
    setDisabledOptions([]);
  }, [proposalData]);

  const handleSelectChange = (event) => {
    const proposalNumber = proposalData.proposalNumber;
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    if (!disabledOptions.includes(selectedValue)) {
      setDisabledOptions([...disabledOptions, selectedValue]);
    }

    dispatch(consentByPass(proposalNumber, selectedValue));
  };

  const options = [];
  if (consent.agentConsentByPass) {
    options.push({ label: "Agent Consent", value: "Agent" });
  }
  if (consent.customerConsentByPass) {
    options.push({ label: "Customer Consent", value: "Customer" });
  }

  const waivedOffHandler = () => {
    if (statusPanON) {
      setshowTpaPan(true)
    }
    else {
      setShowWaivedOff(true);
    }
  };

  const radios = [
    { id: 1, text: "Proposer" },
    { id: 2, text: "Insured" },
    { id: 3, text: "Both" },
  ];

  const waiveOptions = [
    { id: 1, key: "WAIVE_OFF_MEDICALS", text: "Waive off Medical Requirement" },
    // { id: 2, key: "ONLY_TPA", text: "Only TPA" },
    // { id: 3, key: "BYPASS_DEDUPE", text: "Bypass Dedupe" },
  ];
  const handleWaivedType = (e, type) => {
    // console.log("e", e.target.value);
    if (type === "waiveOffOption") {
      setWaivedType(e.target.value);
    } else if (type === "waiveOfFor") {
      setShowWaivedRadio(e.target.value);
    }
  };

  const saveTpaRequest = () => { 
    let tpaProposer;
    let tpaInsured;
    let tpaBoth;
    if (waivedRadio === "Proposer") {
      tpaProposer = true;
      tpaInsured = false;
      tpaBoth = false;
    } else if (waivedRadio === "Insured") {
      tpaProposer = false;
      tpaInsured = true;
      tpaBoth = false;
    } else if (waivedRadio === "Both") {
      tpaProposer = false;
      tpaInsured = false;
      tpaBoth = true;
    }
    let result = {};
    let selectedOption = waiveOptions.find(
      (option) => (option.text === waivedType || option.key === waivedType)
    );
    if (selectedOption) {
      result.key = selectedOption.key;
    }
    let data = {
      waivedOffBy: userDetails?.user?.code,
      // tpaWaiveOffType: result.key,
      tpaWaiveOffType:'WAIVE_OFF_MEDICALS',
      proposalNumber: proposalData.proposalNumber,
      tpaWaiveOffForProposer: tpaProposer,
      tpaWaiveOffFoxrInsured: tpaInsured,
      tpaWaiveOffForBoth: tpaBoth,
      panIndia: false,
    };
    dispatch(
      tpaPoposal(data, (res) => {
        if (res.status === "CREATED") setTPAData(res?.body);
        setShowWaivedOff(false);
        setactiveTpa(true);
        showTpaTab(true);
        setActiveTab("tpa");
        dispatch(getProposalDetails(proposalData.proposalNumber));
      })
    );
  };
  return (
    <>
      <div className="proposal-dashboard proposal-details-page proposalDetails_comp">
        <div className="proposal-dashboard__header proposal-details-page__header">
          <h2 className="proposal-dashboard__title">Proposal Details</h2>
          <p className="proposal-dashboard__subtitle">
            View proposal summary, documents, payments, and related information
          </p>
        </div>

        <div className="proposal-details-page__panel proposal-details-page__summary">
          <h3 className="proposal-details-page__section-title">Proposer Details</h3>
          <div className="proposal-details-page__compact-grid">
            <div className="proposal-details-page__field">
              <span className="proposal-details-page__label">Proposal Number</span>
              <span className="proposal-details-page__value">
                {proposalData.proposalNumber || "-"}
              </span>
            </div>
            <div className="proposal-details-page__field">
              <span className="proposal-details-page__label">Policy Number</span>
              <span className="proposal-details-page__value">
                {proposalData.policyNumber || "-"}
              </span>
            </div>
            <div className="proposal-details-page__field">
              <span className="proposal-details-page__label">Current Status</span>
              <span className="proposal-details-page__value">
                {proposalData.proposalStatus || "-"}
              </span>
            </div>
            <div className="proposal-details-page__field">
              <span className="proposal-details-page__label">Proposer Name</span>
              <span className="proposal-details-page__value">
                {proposalData?.customerDetails?.proposerDetails?.personalDetails
                  ?.firstName || "-"}
              </span>
            </div>
            <div className="proposal-details-page__field">
              <span className="proposal-details-page__label">Insured Name</span>
              <span className="proposal-details-page__value">
                {proposalData?.customerDetails?.insuredDetails?.insuredPersonalDetail
                  ?.firstName || "-"}
              </span>
            </div>
          </div>

          <div className="proposal-details-page__actions">
            {(window.envType === "DEV" ||
              window.envType === "NEWGEN-UAT" ||
              proposalData?.issuanceType !== "EASE") &&
              proposalData?.issuanceType !== "EASE" && (
                <button
                  type="button"
                  className="proposal-details-page__btn proposal-details-page__btn--primary"
                  onClick={waivedOffHandler}
                >
                  TPA Waived off
                </button>
              )}
            {options.length > 0 && proposalData?.issuanceType === "EASE" && (
              <div className="proposal-details-page__field proposal-details-page__field--action">
                <label
                  className="proposal-details-page__label"
                  htmlFor="consentDropdown"
                >
                  Consent
                </label>
                <select
                  className="proposal-details-page__select"
                  id="consentDropdown"
                  value={selectedOption}
                  onChange={handleSelectChange}
                >
                  {options.length > 0 && (
                    <option value="" disabled hidden>
                      Select consent
                    </option>
                  )}
                  {options.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      disabled={disabledOptions.includes(option.value)}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        {waivedOff && (
          <MobilePopUp
            heading={"Waived Off"}
            onClose={() => setShowWaivedOff(false)}
          >
            <div className="proposal-details-page__modal-form">
              <div className="proposal-details-page__field">
                <label className="proposal-details-page__label" htmlFor="waiveOffType">
                  Waive off type
                </label>
                <select
                  className="proposal-details-page__select"
                  id="waiveOffType"
                  value={waivedType}
                  onChange={(event) =>
                    handleWaivedType(event, "waiveOffOption")
                  }
                >
                  {waiveOptions.length > 0 && (
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                  )}
                  {waiveOptions.map((option) => (
                    <option key={option.key} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>
              <div className="proposal-details-page__field">
                <label className="proposal-details-page__label" htmlFor="waiveOffFor">
                  Waive off for
                </label>
                <select
                  className="proposal-details-page__select"
                  id="waiveOffFor"
                  value={waivedRadio}
                  onChange={(event) => handleWaivedType(event, "waiveOfFor")}
                >
                  {radios.length > 0 && (
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                  )}
                  {radios.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </select>
              </div>
              <div className="proposal-details-page__actions">
                <button
                  type="button"
                  className="proposal-details-page__btn proposal-details-page__btn--primary"
                  onClick={saveTpaRequest}
                  disabled={!waivedRadio || !waivedType}
                >
                  Submit
                </button>
              </div>
            </div>
          </MobilePopUp>
        )}

        {Object?.values(proposalData)?.length >= 0 && (
          <div className="proposal-details-page__tabs">
          <TabContainer
            activeKey={activeTab}
            onSelect={(key) => setActiveTab(key)}
            defaultActiveKey="applicationDetails"
          >
            <Tab eventKey="applicationDetails" title="Application Details">
              <Application proposalData={proposalData} />
            </Tab>
            <Tab eventKey="proposerDetails" title="Proposer Details">
              <PropserDetails
                proposerData={proposalData?.customerDetails?.proposerDetails}
                eligibility={
                  proposalData?.basicDetails &&
                  proposalData?.basicDetails?.eligibilityDetails
                }
              />
            </Tab>
            {proposalData?.customerDetails?.policyFor === "OTHER" && (
              <Tab eventKey="inusredDetails" title="Insured Details">
                <InsuredDetails
                  insuredData={proposalData?.customerDetails?.insuredDetails}
                />
              </Tab>
            )}
            {proposalData?.customerDetails?.policyFor === "SELF" && (
              <Tab eventKey="nomineeDetails" title="Nominee Details">
                <Nominee proposalData={proposalData} />
              </Tab>
            )}
            <Tab eventKey="productDetails" title="Product Details">
              <Product proposalData={proposalData} />
            </Tab>
            <Tab eventKey="PaymentDetails" title="Payment Details">
              <PaymentDetails
                proposalData={proposalData}
                paymentDetails={proposalData?.paymentDetails}
              />
            </Tab>
            <Tab eventKey="healthDetails" title="Health Details">
              <HealthQuestions proposalData={proposalData} />
            </Tab>
            <Tab eventKey="documentDetails" title="Document Details">
              <DocumentDetails
                documentDetails={proposalData?.documentDetails}
                proposalNumber={proposalNumber}
              />
            </Tab>
            <Tab eventKey="declarationDetails" title="Declaration Details">
              <Declaration proposalData={proposalData} />
            </Tab>
            <Tab eventKey="importantLinks" title="Important Links">
              <ImportantLink proposalData={proposalData} />
            </Tab>
            <Tab eventKey="logs" title="Logs">
              <ProposalLogs
                proposalData={proposalData}
                proposal={proposalNumber}
              />
            </Tab>
            {
              // tpaTab && 
              (
                <Tab eventKey="tpa" title="TPA Details">
                  <TPADetails proposalData={proposalData} TPAData={TPAData} />
                </Tab>
              )}
          </TabContainer>
          </div>
        )}

        {showTpaPan && (
          <div className="tpa-pop proposal-details-page__dialog">
            <span className="backgroundOverlay"></span>
            <div className="tpapopup proposal-details-page__dialog-content">
              <span className="close-btn" onClick={() => setshowTpaPan(false)}>
                <img alt="Close" src={closeImg} />
              </span>
              <div className="proposal-details-page__dialog-title">
                Waive Off Medicals (PAN India)
              </div>
              <div className="proposal-details-page__dialog-message">
                in Proposal Submission Switch tab is ON.
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProposalDetailsComp;
